module.exports = __webpack_public_path__ + "ff3788b9c6faf3a799ce3aca72b8a23d.png";